import { FunctionalComponent, h } from 'preact';

import styled from 'styled-components';

const Background = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.ui.overlay.color};
  opacity: ${({ theme }) => theme.ui.overlay.opacity};
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 2147483639;
  overflow: hidden !important;
`;

const Overlay: FunctionalComponent = () => {
  return <Background />;
};

export default Overlay;
